import Http from '@/api/http.js'

export default {
  
  indexGoals(filter){
    return Http.get(`/seller_reports`, {params: {...filter}});
  },

  createGoal(goal){
    return Http.post(`/seller_reports`, {
      seller_report: {...goal}
    });
  },
  updateGoal(goal){
    return Http.put(`/seller_reports/${goal.id}`, {
      seller_report: {...goal}
    });
  },

  updateSellerGoals(goal){
    let {id, seller_goals} = goal
    return Http.put(`/seller_reports/${id}`, {
      seller_report: {id, seller_goals}
    });
  },

  showReport(filter){
    return Http.get(`/seller_reports_service`, {
      params: {...filter}
    });
  },
  indexSellerReports(filter){
    return Http.get(`/seller_reports_service`, {
      params: {...filter}
    });
  },
  indexModalitySellerReports(filter){
    return Http.get(`/modality_seller_reports`, {
      params: {...filter}
    });
  },

  getReportLineData(date, params){
    return Http.get(`/seller_reports_timeline_service?date=${date}`, { params });
  }

  
}